module.exports = __webpack_public_path__ + "fonts/WorkSans-Black.949e78e.eot";